export default "__VITE_ASSET__U90bTqBs__"